import React from 'react';

// Other Information - No. of Startups Invested In. 36x36 gradient-bordered tile
// (the frame is part of the artwork), glyph exactly as Figma drew it. Gradient
// ids are per-instance (useId) so several icons on one page don't share ids and
// break.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7458F6" />
    <stop offset="1" stopColor="#84AEF8" />
  </>
);

const WINDOWS = [
  { key: 2, x: '15', y: '13.5' },
  { key: 3, x: '20', y: '13.5' },
  { key: 4, x: '15', y: '17.5' },
  { key: 5, x: '20', y: '17.5' },
  { key: 6, x: '15', y: '21.5' },
  { key: 7, x: '20', y: '21.5' },
];

const StartupsInvestedIcon = ({ size = 36 }) => {
  const uid = React.useId();
  const g = (n) => `startups_invested_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <rect x="11.5" y="10.5" width="14" height="17" rx="1" stroke={`url(#${g(1)})`} />
      {WINDOWS.map((w) => (
        <rect
          key={w.key}
          x={w.x}
          y={w.y}
          width="1.5"
          height="1.5"
          stroke={`url(#${g(w.key)})`}
        />
      ))}
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(1)} x1="18.5" y1="10" x2="18.5" y2="28" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(2)} x1="15.75" y1="13" x2="15.75" y2="15.5" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(3)} x1="20.75" y1="13" x2="20.75" y2="15.5" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(4)} x1="15.75" y1="17" x2="15.75" y2="19.5" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(5)} x1="20.75" y1="17" x2="20.75" y2="19.5" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(6)} x1="15.75" y1="21" x2="15.75" y2="23.5" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(7)} x1="20.75" y1="21" x2="20.75" y2="23.5" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StartupsInvestedIcon;
